import { HTTP } from "./HttpServices";
const endpoint = "/supplies";

const getSupplies = query => {
  return HTTP.get(endpoint.concat(query)).then(resp => resp);
};

const create = supply => {
  return HTTP.post(endpoint, supply);
};

const update = supply => {
  return HTTP.put(endpoint.concat("/", supply.id), supply);
};

const remove = supplyId => {
  return HTTP.delete(endpoint.concat("/", supplyId));
};

export default {
  getSupplies,
  create,
  update,
  remove
};
